import { trackAmplitudeEvent } from "../../amplitude";

// One place for the station's events, so every one of them carries the same
// properties. The funnel this page exists to measure is: tuned in -> opened the
// save form -> saved something, split by whether the visitor could save at all.
//
// Without signedIn and isPro on every event, a launch tells you how many people
// listened and nothing about how many hit the wall - which is the number that
// decides whether the wall should move.
export default function track(context) {
  return (event, properties = {}) => trackAmplitudeEvent(`web_app_infinite_radio_${event}`, {
    cefr_level: context.cefrLevel,
    is_pro: context.isPro,
    language_studied: context.language,
    signed_in: context.signedIn,
    ...properties,
  });
}
